{
  "resource.label": "Resource",
  "resource.node": "Resource node",
  "resource.insufficient": "Not enough resource",
  "unit.worker": "Engineer",
  "unit.melee": "Wheeled IFV",
  "unit.ranged": "Heavy Tank",
  "unit.siege": "Self-Propelled Artillery",
  "worker.task.idle": "Idle",
  "worker.task.moveToNode": "Moving",
  "worker.task.gathering": "Gathering resource",
  "worker.task.moveToHq": "Returning",
  "worker.task.depositing": "Depositing resource",
  "worker.task.building": "Building",
  "entity.hq": "Command Hub",
  "entity.barracks": "Field Factory",
  "entity.mineral": "Resource node",
  "command.train.worker": "Train Engineer",
  "command.train.melee": "Produce IFV",
  "command.train.ranged": "Produce Heavy Tank",
  "command.train.siege": "Produce Artillery",
  "command.buildBarracks": "Build Factory",
  "command.buildBarracks.unlocks": "Unlocks:",
  "command.stop": "Stop",
  "command.move": "Move",
  "command.attack": "Attack",
  "command.hold": "Hold",
  "command.harvest": "Harvest",
  "cursor.build": "Build",
  "hotkey.assign": "Assign",
  "hotkey.recall": "Recall",
  "hotkey.add": "Add",
  "alert.invalidBuildPlacement": "Cannot build here",
  "alert.underAttack": "Command Hub under attack",
  "hud.minimap.label": "Minimap",
  "selection.none": "No selection",
  "selection.units": "units",
  "stat.role": "Role",
  "stat.hp": "HP",
  "stat.damage": "Damage",
  "stat.range": "Range",
  "stat.rangeShort": "Rng",
  "stat.aoe": "AOE",
  "stat.aoeShort": "AOE",
  "stat.speed": "Speed (tiles/s)",
  "stat.speedShort": "Spd (tiles/s)",
  "stat.cooldown": "Cooldown",
  "stat.cooldownShort": "CD",
  "stat.cost": "Cost",
  "stat.trainTime": "Train",
  "stat.strongVs": "Strong vs",
  "stat.weakVs": "Weak vs",
  "stat.strong": "Strong",
  "stat.weak": "Weak",
  "stat.cargo": "Cargo",
  "stat.none": "none",
  "stat.secondsSuffix": "s",
  "stat.ticksSuffix": "ticks",
  "stat.ticksShortSuffix": "t",
  "counter.utility": "Utility",
  "counter.neutral": "neutral",
  "counter.buildings": "buildings",
  "briefing.line": "Secure the sector. Gather resources and destroy the enemy HQ."
}
